<!--components\Boletas\PanelBoletas.vue-->
<template>

  <!-- panel padre -->
  <div
    class="efecto_fondo bg-gray-100 flex flex-col w-full h-auto pt-[2rem] md:pt-[4rem] pb-[8rem] md:pb-[8rem] px-[0.8rem] md:px-[12rem]">

    <!-- panel contenedor central -->
    <div class="flex flex-col md:flex-row bg-transparent gap-[1rem] md:gap-[6rem] w-full">

      <!-- panel izquierdo -->
      <div
        v-if="etapa !== 'verificado'"
        class="flex-col gap-[1rem] w-[100%] md:w-[50%] items-left"
        :class="clasePanelIzquierdo"
      >
        <p class="text-sm font-bold text-ROJO_TITULOS_LEON">Boleta electrónica</p>
        <h1 class="text-2xl md:text-6xl font-extrabold text-black tracking-tighter">REVISA TU <br> BOLETA</h1>
        <p class="texrt-base">Consulta el detalle de lo que pagaste, descarga tu boleta en PDF y revisa las garantías
          vigentes de tu atención.</p>

        <!--contendor descriptivo-->
        <div class="hidden md:flex flex-col">
          <!--tarjeta-->
          <div class="flex flex-row items-center gap-[1rem] border-t border-slate-300 py-[1rem]">
            <div class="flex flex-col h-[2.4rem] w-[2.4rem] bg-rose-100 rounded-md py-2 px-1 justify-center text-ROJO_TITULOS_LEON items-center">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
                stroke-linecap="round" stroke-linejoin="round" class="h-full w-auto">
                <path d="M6 2h9l5 5v15H6z"></path>
                <path d="M15 2v5h5"></path>
                <path d="M9.5 12h6M9.5 15.5h4"></path>
              </svg>
            </div>
            <p class="text-sm">Detalle completo de productos, servicios y mano de obra</p>
          </div>

          <!--tarjeta-->
          <div class="flex flex-row items-center gap-[1rem] border-t border-slate-300 py-[1rem]">
            <div class="flex flex-col h-[2.4rem] w-[2.4rem] bg-rose-100 rounded-md py-2 px-1 justify-center text-ROJO_TITULOS_LEON items-center">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
                stroke-linecap="round" stroke-linejoin="round" class="h-full w-auto">
                <path d="M6 2h9l5 5v15H6z"></path>
                <path d="M15 2v5h5"></path>
                <path d="M12 11v6M9.5 14.5L12 17l2.5-2.5"></path>
              </svg>
            </div>
            <p class="text-sm">Descarga del documento tributario en PDF</p>
          </div>

          <!--tarjeta-->
          <div class="flex flex-row items-center gap-[1rem] border-b border-t border-slate-300 py-[1rem]">
            <div class="flex flex-col h-[2.4rem] w-[2.4rem] bg-rose-100 rounded-md py-2 px-1 justify-center text-ROJO_TITULOS_LEON items-center">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
                stroke-linecap="round" stroke-linejoin="round" class="h-full w-auto">
                <path d="M12 2.8l7.4 3v5.6c0 4.3-3 8.2-7.4 9.8-4.4-1.6-7.4-5.5-7.4-9.8V5.8z"></path>
                <path d="M9 12l2.2 2.2L15.4 10"></path>
              </svg>
            </div>
            <p class="text-sm">Garantías vigentes con su fecha de término</p>
          </div>
        </div>
      </div>

      <!-- panel derecho -->
      <div
        class="flex flex-col w-full md:transition-all items-left rounded-lg border-none md:border border-slate-300 shadow-none md:shadow-md gap-[1rem] h-fit"
        :class="clasesPanelDerecho"
      >
        <BarraProgreso :paso-actual="pasoActual" />

        <ModalSesionExpirada
          v-if="sesionExpirada"
          @reintentar="reiniciarPorSesionExpirada"
        />

        <!--etapa modo-->
        <div v-if="etapa === 'modo'" class="flex flex-col gap-[1rem] h-fit w-full">
          <p class="hidden md:flex flex-col text-lg font-bold text-black">ELIGE COMO BUSCARLA</p>

          <TarjetaOpcion
            titulo="Tengo la boleta a mano"
            subtitulo="Necesitas el número de folio y el total pagado"
            :svg-tipo="1"
            @click="tengoBoleta"
          />

          <TarjetaOpcion
            titulo="No tengo la boleta"
            subtitulo="Búscala con la patente del vehículo y la fecha"
            :svg-tipo="2"
            @click="noTengoBoleta"
          />
        </div>


        <!--etapa tengo_boleta (folio + monto)-->
        <div v-if="etapa === 'folio'" class="flex flex-col w-full gap-[1rem] h-fit">
          <BotonAnimadoTipo1
            button-classes="flex flex-row-reverse items-center rounded-lg bg-transparent font-bold text-ROJO_TITULOS_LEON text-sm md:text-base py-2 px-1 hover:bg-transparent"
            :svg-tipo="5" @click="etapa = 'modo'" texto="Volver"
          />
          <p class="text-black text-lg font-bold">IDENTIFICA TU BOLETA</p>
          <p class="text-black text-base">Los dos datos están impresos en el documento. Los pedimos juntos para confirmar que la boleta está en tus manos.</p>

          <MensajeError v-if="errorFolio" :texto="errorFolio" />

          <CampoTexto
            label="NÚMERO DE FOLIO"
            :model-value="form.folio"
            @update:model-value="actualizarFolio"
            inputmode="numeric"
            maxlength="9"
            placeholder="1048372"
            hint='Arriba a la derecha, junto a "Boleta electrónica N°".'
            @keydown-enter="buscarPorFolio"
          />

          <CampoTexto
            label="TOTAL PAGADO"
            :model-value="form.monto"
            @update:model-value="actualizarMonto"
            inputmode="numeric"
            placeholder="$189.900"
            hint="El monto exacto, sin decimales."
            @keydown-enter="buscarPorFolio"
          />

          <BotonAnimadoTipo1
            button-classes="flex flex-row-reverse items-center rounded-lg bg-red-700 font-bold text-white text-sm md:text-base py-2 px-4 hover:bg-VERDE_TOP_CALIDAD disabled:opacity-60"
            :svg-tipo="8" @click="buscarPorFolio" :texto="textoBotonBuscarFolio"
          />
        </div>


        <!--etapa patente (patente + correo + fecha)-->
        <div v-if="etapa === 'patente'" class="flex flex-col w-full gap-[1rem] h-fit">
          <BotonAnimadoTipo1
            button-classes="flex flex-row-reverse items-center rounded-lg bg-red-transparent font-bold text-ROJO_TITULOS_LEON text-sm md:text-base py-2 px-1 hover:bg-transparent"
            :svg-tipo="5" @click="etapa = 'modo'" texto="Volver"
          />
          <p class="text-black text-lg font-bold">BUSCA POR PATENTE</p>
          <p class="text-black text-base">Necesitamos la patente y el correo que dejaste al momento de la atención. Deben coincidir para poder mostrarte algo.</p>

          <MensajeError v-if="errorPatente" :texto="errorPatente" />

          <CampoTexto
            label="PATENTE"
            :model-value="form.patente"
            @update:model-value="actualizarPatente"
            maxlength="8"
            placeholder="KJXR41"
            uppercase
            hint="Con o sin guiones. Aceptamos formato antiguo y nuevo."
            @keydown-enter="() => correoCampoRef?.focus()"
          />

          <CampoTexto
            ref="correoCampoRef"
            label="CORREO REGISTRADO EN LA VENTA"
            v-model="form.correo"
            type="email"
            placeholder="nombre@correo.cl"
            hint="El mismo que entregaste en el mesón o al agendar la hora."
            @keydown-enter="buscarPorPatente"
          />

          <CampoTexto
            label="FECHA APROXIMADA"
            opcional
            v-model="form.fecha"
            type="date"
            hint="Si la indicas, buscamos en un rango de 3 días. Si la dejas vacía, te mostramos todas las boletas del último año."
            @keydown-enter="buscarPorPatente"
          />

          <BotonAnimadoTipo1
            button-classes="flex flex-row-reverse items-center rounded-lg bg-red-700 font-bold text-white text-sm md:text-base py-2 px-4 hover:bg-VERDE_TOP_CALIDAD disabled:opacity-60"
            :svg-tipo="8" @click="buscarPorPatente" :texto="textoBotonBuscarPatente"
          />

          <BotonAnimadoTipo1
            button-classes="flex flex-row-reverse items-center bg-transparent text-ROJO_TITULOS_LEON underline text-sm font-normal py-1 px-0 hover:bg-transparent"
            :svg-tipo="0" @click="etapa = 'folio'" texto="¿No recuerdas el correo? Busca con el folio y el monto"
          />
        </div>

        <!--etapa lista (varios resultados por patente)-->
        <div v-if="etapa === 'lista'" class="flex flex-col w-full gap-[1rem] h-fit">
          <BotonAnimadoTipo1
            button-classes="flex flex-row-reverse items-center rounded-lg bg-red-700 font-bold text-white text-sm md:text-base py-2 px-4 hover:bg-VERDE_TOP_CALIDAD"
            :svg-tipo="5" @click="etapa = 'patente'" texto="Cambiar búsqueda"
          />
          <p class="text-black text-lg font-bold">ELIGE LA BOLETA</p>
          <p class="text-black text-base">
            Encontramos <b>{{ boletasEncontradas.length }} boletas</b> asociadas a la patente {{ form.patente }}.
          </p>

          <button
            v-for="b in boletasEncontradas"
            :key="b.folio"
            type="button"
            class="flex flex-row w-full p-[1rem] gap-[1rem] bg-gray-50 rounded-md items-center justify-between border border-slate-300 hover:border-ROJO_FUERTE_LEON transition-colors text-left"
            @click="elegirBoleta(b)"
          >
            <div class="flex flex-col">
              <span class="text-xs text-GRIS_BORDES">FOLIO {{ b.folio }}</span>
              <span class="text-base text-black font-bold">{{ b.sucursal }}</span>
              <span class="text-xs text-GRIS_BORDES">{{ b.fecha }}</span>
            </div>
            <span class="text-base font-bold text-black">$ {{ b.total.toLocaleString('es-CL') }}</span>
          </button>
        </div>

        <!--etapa resultado / canal (resumen + QR acceso rápido + elegir canal)-->
        <div v-if="etapa === 'resultado'" class="flex flex-col w-full gap-[1rem] h-fit">
          <BotonAnimadoTipo1
            button-classes="flex flex-row-reverse items-center rounded-lg bg-transparent font-bold text-ROJO_TITULOS_LEON text-sm md:text-base py-2 px-1 hover:bg-transparent"
            :svg-tipo="5" @click="etapa = 'modo'" texto="Empezar de nuevo"
          />
          <p class="text-black text-lg font-bold">ENCONTRAMOS TU BOLETA</p>
          <p class="text-black text-base">Para ver el detalle, descargar el PDF y revisar garantías, te enviamos un código al contacto registrado en la venta.</p>

          <div class="flex flex-col gap-[0.4rem] bg-gray-50 rounded-xl p-[1rem] border border-slate-300">
            <div class="flex flex-row justify-between">
              <span class="text-base text-black font-bold">BOLETA N° {{ boleta.folio }}</span>
            </div>
            <div class="flex flex-row justify-between">
              <span class="text-base text-black">Fecha</span>
              <span class="text-base text-black">{{ boleta.fecha }}</span>
            </div>
            <div class="flex flex-row justify-between">
              <span class="text-base text-black">Sucursal</span>
              <span class="text-base text-black">{{ boleta.sucursal }}</span>
            </div>
            <div class="flex flex-row justify-between">
              <span class="text-base text-black">Estado</span>
              <span class="text-base text-black">Vigente</span>
            </div>
            <div class="flex flex-row justify-between border-t border-slate-300 pt-[0.4rem] mt-[0.4rem]">
              <span class="text-base text-black font-bold">Total pagado</span>
              <span class="text-base font-bold text-black">$ {{ boleta.total.toLocaleString('es-CL') }}</span>
            </div>
          </div>

          <!--acceso rápido con QR
          <div class="flex flex-col md:flex-row gap-[1rem] bg-gray-50 rounded-xl p-[1rem] border border-slate-300 items-center">
            <div class="flex flex-col shrink-0 p-[0.4rem] w-[8rem] h-[8rem] rounded-md border border-slate-300 bg-white">
              <img :src="qrAccesoRapido" alt="Código QR de acceso rápido" class="flex flex-col h-full w-full" />
            </div>
            <div class="flex flex-col gap-[0.3rem]">
              <p class="text-black text-base font-bold">Acceso rápido</p>
              <p class="text-black text-sm">Escanea este código con tu celular para volver a esta boleta sin escribir los datos de nuevo. Sácale una foto o guárdalo.</p>
              <BotonAnimadoTipo1
                button-classes="flex flex-row-reverse items-center bg-transparent text-ROJO_TITULOS_LEON underline text-sm font-semibold py-1 px-0 hover:bg-transparent w-fit"
                :svg-tipo="0" @click="guardarQr" texto="Guardar imagen"
              />
            </div>
          </div>
          -->

          <!--elegir canal para el código, o aviso si no hay contacto registrado-->
          <template v-if="boleta.contacto">
            <p class="text-black text-sm font-semibold">ENVIAR CÓDIGO A</p>
            <SelectorCanal v-model="canalSeleccionado" :opciones="opcionesCanal" />

            <BotonAnimadoTipo1
              button-classes="flex items-center rounded-lg bg-red-700 font-bold text-white text-sm md:text-base py-2 px-4 hover:bg-VERDE_TOP_CALIDAD"
              :svg-tipo="1" @click="enviarCodigo" texto="Enviar código"
            />
          </template>

          <template v-else>
            <div class="border border-amber-400 rounded-lg flex flex-row py-[0.6rem] px-[1rem] text-sm bg-amber-50 gap-[0.6rem] items-center">
              <div class="h-[1.4rem] w-[1.4rem] rounded-md justify-center text-amber-600">
                <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="h-full w-auto">
                  <path d="M12 4l9 16H3z" stroke-linejoin="round"></path>
                  <path d="M12 10v4M12 17.2v.1" stroke-linecap="round"></path>
                </svg>
              </div>
              <p class="text-amber-600 text-sm">Esta venta no tiene correo ni teléfono registrado, así que no podemos enviarte un código. Escríbenos y un ejecutivo valida tus datos.</p>
            </div>

            <BotonAnimadoTipo1
              button-classes="w-full justify-center flex flex-row-reverse items-center rounded-lg bg-red-700 font-bold text-white text-sm md:text-base py-2 px-4 hover:bg-VERDE_TOP_CALIDAD"
              :svg-tipo="0" @click="irAConsulta('resultado')" texto="Escribir a un ejecutivo"
            />
            <BotonAnimadoTipo1
              button-classes="w-full justify-center flex flex-row-reverse items-center rounded-lg bg-[#458926] font-bold text-white text-sm md:text-base py-2 px-4 hover:bg-[#3A7420]"
              :svg-tipo="7" @click="abrirWhatsapp" texto="Abrir WhatsApp"
            />
          </template>
        </div>

        <!--etapa otp (verificación por código)-->
        <div v-if="etapa === 'otp'" class="flex flex-col w-full gap-[1rem] h-fit">
          <BotonAnimadoTipo1
            button-classes="flex flex-row-reverse items-center rounded-lg bg-red-700 font-bold text-white text-sm md:text-base py-2 px-4 hover:bg-VERDE_TOP_CALIDAD"
            :svg-tipo="5" @click="etapa = 'resultado'" texto="Usar otro contacto"
          />
          <p class="text-black text-lg font-bold">INGRESA EL CÓDIGO</p>
          <p class="text-black text-base">
            Enviamos 6 dígitos a <b>{{ canalElegidoTexto }}</b>. El código vence en 5 minutos.
          </p>

          <MensajeError v-if="errorOtp" :texto="errorOtp" />

          <CasillasOtp
            ref="casillasOtpRef"
            :model-value="codigoOtp"
            @input-casilla="onInputOtp"
            @keydown-casilla="onKeydownOtp"
          />

          <p class="text-black text-sm">{{ textoContadorOtp }}</p>

          <div class="flex flex-row justify-between">
            <BotonAnimadoTipo1
              button-classes="flex flex-row-reverse items-center rounded-lg bg-red-700 font-bold text-white text-sm md:text-base py-2 px-4 hover:bg-VERDE_TOP_CALIDAD disabled:opacity-60"
              :svg-tipo="8" @click="validarCodigo" :texto="textoBotonValidarCodigo"
            />
            <BotonAnimadoTipo1
              button-classes="flex flex-row-reverse items-center bg-transparent text-ROJO_TITULOS_LEON underline text-sm font-normal py-1 px-0 hover:bg-transparent disabled:opacity-50 disabled:cursor-not-allowed"
              :svg-tipo="0"
              :disabled="!puedeReenviarCodigo"
              @click="reenviarCodigo"
              :texto="textoBotonReenviar"
            />
          </div>
        </div>

        <!--etapa verificado (pdf real embebido + resumen + acciones)-->
        <div v-if="etapa === 'verificado'" class="flex flex-col w-full gap-[1rem] h-fit">
          <div class="flex flex-row items-center gap-[0.4rem]">
            <span class="w-2 h-2 rounded-full bg-VERDE_TOP_CALIDAD"></span>
            <p class="text-sm font-semibold text-VERDE_TOP_CALIDAD">Identidad verificada</p>
          </div>

          <div class="flex flex-col md:flex-row w-full gap-[1.5rem]">
            <!--panel izquierdo: pdf real-->
            <div class="flex flex-col w-full md:w-[60%] h-[500px] rounded-xl border border-slate-300 bg-gray-50 overflow-hidden">
              <div v-if="cargandoPdfPanel" class="flex flex-col items-center justify-center h-full gap-[0.6rem]">
                <p class="text-sm text-GRIS_BORDES">Cargando tu boleta…</p>
              </div>
              <div v-else-if="errorPdfPanel" class="flex flex-col items-center justify-center h-full gap-[0.6rem] px-[1rem] text-center">
                <p class="text-sm text-ROJO_TITULOS_LEON">No pudimos mostrar el documento aquí.</p>
                <BotonAnimadoTipo1
                  button-classes="flex flex-row-reverse items-center rounded-lg bg-red-700 font-bold text-white text-sm py-2 px-4 hover:bg-VERDE_TOP_CALIDAD"
                  :svg-tipo="0" @click="cargarPdfEnPanel" texto="Reintentar"
                />
              </div>
              <iframe v-else :src="pdfUrl" class="w-full h-full" title="Boleta en PDF"></iframe>
            </div>

            <!--panel derecho: resumen + acciones-->
            <div class="flex flex-col w-full md:w-[40%] gap-[1rem]">
              <div class="flex flex-col gap-[0.4rem] bg-gray-50 rounded-xl p-[1rem] border border-slate-300">
                <span class="text-base text-black font-bold">BOLETA N° {{ boleta.folio }}</span>
                <div class="flex flex-row justify-between">
                  <span class="text-base text-black">Fecha</span>
                  <span class="text-base text-black">{{ boleta.fecha }}</span>
                </div>
                <div class="flex flex-row justify-between">
                  <span class="text-base text-black">Patente</span>
                  <span class="text-base text-black">{{ boleta.patente }}</span>
                </div>
                <div class="flex flex-row justify-between">
                  <span class="text-base text-black">Sucursal</span>
                  <span class="text-base text-black">{{ boleta.sucursal }}</span>
                </div>
                <div class="flex flex-row justify-between border-t border-slate-300 pt-[0.4rem] mt-[0.4rem]">
                  <span class="text-base text-black font-bold">Total pagado</span>
                  <span class="text-base font-bold text-black">$ {{ boleta.total.toLocaleString('es-CL') }}</span>
                </div>
              </div>

              <!--acciones-->
              <div class="flex flex-col gap-[1rem] items-center w-full">
                <BotonAnimadoTipo1
                  claseBase="flex w-full flex-row"
                  button-classes="justify-center w-full flex flex-row-reverse items-center rounded-lg bg-red-700 font-bold text-white text-sm md:text-base py-[0.6rem] px-4 hover:bg-VERDE_TOP_CALIDAD disabled:opacity-60"
                  :svg-tipo="0" :disabled="!pdfUrl" @click="descargarPdf" texto="Descargar boleta en PDF"
                />
                <BotonAnimadoTipo1
                  claseBase="flex w-full flex-row"
                  button-classes="justify-center w-full flex flex-row-reverse items-center rounded-lg bg-white border border-slate-300 font-bold text-black text-sm md:text-base py-[0.6rem] px-4 hover:border-ROJO_FUERTE_LEON"
                  :svg-tipo="0" @click="irAConsulta('verificado')" texto="Tengo una consulta"
                />
                <BotonAnimadoTipo1
                  claseBase="flex w-full flex-row"
                  button-classes="justify-center w-full flex flex-row-reverse items-center bg-transparent text-ROJO_TITULOS_LEON underline text-sm font-normal py-[0.6rem] px-0 hover:bg-transparent"
                  :svg-tipo="0" @click="etapa = 'modo'" texto="Consultar otra boleta"
                />
              </div>
            </div>
          </div>
        </div>

        <!--etapa consulta (formulario de contacto)-->
        <div v-if="etapa === 'consulta'" class="flex flex-col w-full gap-[1rem] h-fit">
          <BotonAnimadoTipo1
            button-classes="flex flex-row-reverse items-center rounded-lg bg-transparent font-bold text-ROJO_TITULOS_LEON text-sm md:text-base py-2 px-1 hover:bg-transparent"
            :svg-tipo="5" @click="etapa = etapaAnteriorConsulta" texto="Volver"
          />
          <p class="text-black text-lg font-bold">CUÉNTANOS QUÉ PASÓ</p>
          <p class="text-black text-base">
            Tu consulta queda asociada a la boleta <b>N° {{ boleta.folio }}</b>. Respondemos en un plazo de 2 días hábiles.
          </p>

          <MensajeError v-if="errorConsulta" :texto="errorConsulta" />

          <CampoSelect label="MOTIVO" v-model="form.motivo" placeholder="Selecciona un motivo" :opciones="motivosConsulta" />

          <p class="text-black text-base font-semibold">DETALLE</p>
          <textarea
            v-model="form.detalle"
            rows="4"
            placeholder="Describe lo que pasó con el mayor detalle posible."
            class="px-[1rem] py-[0.6rem] w-full text-base text-black placeholder:text-gray-300 bg-gray-100 rounded-xl border-gray-300 focus:ring-0 focus:border-ROJO_TITULOS_LEON focus:ring-ROJO_TITULOS_LEON"
          ></textarea>

          <CampoTexto
            label="TELÉFONO DE CONTACTO"
            v-model="form.contacto"
            type="tel"
            placeholder="+56 9 1234 5678"
            hint="Lo usamos solo para responder esta consulta."
          />

          <div v-if="mostrarAvisoAnulacion" class="border border-amber-400 rounded-lg flex flex-row py-[0.4rem] px-[1rem] text-sm bg-amber-50 gap-[0.4rem] items-center">
            <span class="text-black text-sm">Las anulaciones y notas de crédito se validan con un ejecutivo. Te contactamos para coordinar y necesitarás presentar tu cédula de identidad.</span>
          </div>

          <BotonAnimadoTipo1
            button-classes="flex flex-row items-center rounded-lg bg-red-700 font-bold text-white text-sm md:text-base py-2 px-4 hover:bg-VERDE_TOP_CALIDAD disabled:opacity-60"
            :svg-tipo="1" @click="enviarConsulta" :texto="textoBotonEnviarConsulta"
          />
        </div>

        <!--etapa listo (consulta enviada)-->
        <div v-if="etapa === 'listo'" class="flex flex-col w-full gap-[1rem] h-fit items-center text-center">
          <div class="h-[3.2rem] w-[3.2rem] rounded-full bg-emerald-100 text-VERDE_TOP_CALIDAD flex items-center justify-center">
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
              <path d="M20 6L9 17l-5-5"></path>
            </svg>
          </div>
          <p class="text-black text-lg font-bold">CONSULTA ENVIADA</p>
          <p class="text-black text-base">Guarda este número. Te sirve para hacer seguimiento por teléfono o en cualquier sucursal.</p>
          <p class="font-mono text-xl font-bold text-black bg-gray-100 rounded-xl px-[1.2rem] py-[0.6rem]">{{ ticket }}</p>

          <BotonAnimadoTipo1
            button-classes="flex flex-row-reverse items-center rounded-lg bg-red-700 font-bold text-white text-sm md:text-base py-2 px-4 hover:bg-VERDE_TOP_CALIDAD"
            :svg-tipo="0" @click="reiniciar" texto="Volver al inicio"
          />
        </div>

      </div>

    </div>
  </div>

</template>

<script setup>

// --- Imports ---
import { computed, onMounted, reactive, ref } from "vue";
import BotonAnimadoTipo1 from "~/components/Botones/BotonAnimadoTipo1.vue";
import MensajeError from "~/components/Boletas/MensajeError.vue";
import CampoTexto from "~/components/Boletas/CampoTexto.vue";
import CampoSelect from "~/components/Boletas/CampoSelect.vue";
import TarjetaOpcion from "~/components/Boletas/TarjetaOpcion.vue";
import SelectorCanal from "~/components/Boletas/SelectorCanal.vue";
import CasillasOtp from "~/components/Boletas/CasillasOtp.vue";
import BarraProgreso from "~/components/Boletas/BarraProgreso.vue";
import ModalSesionExpirada from "~/components/Boletas/ModalSesionExpirada.vue";
import { useStore } from "vuex";
const store = useStore();

const {
  buscarBoletaPorFolio,
  buscarBoletasPorPatente,
  enviarCodigoOtp,
  validarCodigoOtp,
  descargarPdfBoleta,
  enviarConsultaBoleta,
  validarAccesoRapido,
} = useBoletas();

// --- Refs a componentes hijos (para enfocar / controlar DOM desde el padre) ---
const correoCampoRef = ref(null);
const casillasOtpRef = ref(null);

// --- Refs de estado ---
// Etapa activa: 'modo' | 'folio' | 'patente' | 'resultado' | 'otp' | 'verificado' | 'consulta' | 'listo'
const etapa = ref("modo");
const cargando = ref(false);
const errorFolio = ref("");
const errorPatente = ref("");
const boleta = ref(null);
const boletasEncontradas = ref([]);
const canalSeleccionado = ref("fono");

// OTP
const codigoOtp = ref(["", "", "", "", "", ""]);
const errorOtp = ref("");
const segundosOtp = ref(0);
const reenvioSegundos = ref(0);

// PDF (panel embebido en la etapa verificado)
const pdfUrl = ref(null);
const cargandoPdfPanel = ref(false);
const errorPdfPanel = ref(false);

// Consulta / soporte
const errorConsulta = ref("");
const ticket = ref("");
const etapaAnteriorConsulta = ref("verificado");

// --- Reactive ---
const form = reactive({
  folio: "",
  monto: "",
  patente: "",
  correo: "",
  fecha: "",
  motivo: "",
  detalle: "",
  contacto: "",
});

// --- Const / config ---
const config = useRuntimeConfig();
const debug = {
  enabled: config.public.modo === 'DEV',
  log: (...args) => debug.enabled && console.log(...args),
  error: (...args) => debug.enabled && console.error(...args),
};

// Igual al objeto PASOS del boceto: cuántos segmentos rellenar según la etapa.
const PASOS_POR_ETAPA = {
  modo: 0,
  folio: 1,
  patente: 1,
  lista: 1,
  resultado: 2,
  otp: 3,
  verificado: 4,
  consulta: 4,
  listo: 4,
};

const sesionExpirada = computed(() => store.getters['boletas/getSesionExpirada']);

const pasoActual = computed(() => PASOS_POR_ETAPA[etapa.value] ?? 0);
let timerOtp = null;

const motivosConsulta = [
  "Quiero usar la garantía de un producto o servicio",
  "Me cobraron algo que no corresponde",
  "Necesito una copia de la boleta",
  "El servicio quedó mal ejecutado",
  "Quiero anular la boleta o pedir nota de crédito",
  "Otro motivo",
];

// --- Computed ---
const clasePanelIzquierdo = computed(() =>
  etapa.value === "modo" ? "flex" : "hidden md:flex"
);

const clasesPanelDerecho = computed(() => [
  etapa.value === "verificado" ? "md:w-full" : "md:w-[50%]",
  etapa.value === "modo" ? "bg-transparent md:bg-white p-[0rem] md:p-[2rem]" : "bg-white p-[1rem] md:p-[2rem]",
]);

const textoBotonBuscarFolio = computed(() => (cargando.value ? "Buscando…" : "Buscar boleta"));
const textoBotonBuscarPatente = computed(() => (cargando.value ? "Buscando…" : "Buscar boletas"));
const textoBotonValidarCodigo = computed(() => (cargando.value ? "Validando…" : "Validar código"));
const textoBotonEnviarConsulta = computed(() => (cargando.value ? "Enviando…" : "Enviar consulta"));

const puedeReenviarCodigo = computed(() => reenvioSegundos.value === 0);
const textoBotonReenviar = computed(() =>
  puedeReenviarCodigo.value ? "Reenviar código" : `Reenviar código en ${reenvioSegundos.value}s`
);

function actualizarFolio(valor) {
  form.folio = valor.replace(/[^\d]/g, "");
}

function actualizarMonto(valor) {
  const n = valor.replace(/[^\d]/g, "");
  form.monto = n ? parseInt(n, 10).toLocaleString("es-CL") : "";
}

function actualizarPatente(valor) {
  form.patente = valor.toUpperCase().replace(/[^A-Z0-9]/g, "");
}

const qrAccesoRapido = computed(() => {
  if (!boleta.value?.qr_acceso_rapido_base64) return "";
  return `data:image/png;base64,${boleta.value.qr_acceso_rapido_base64}`;
});

const opcionesCanal = computed(() => {
  if (!boleta.value) return [];
  return [
    { value: "fono", label: "Mensaje por WhatsApp", valorMostrado: enmascararFono(boleta.value.contacto.fono) },
    { value: "correo", label: "Correo", valorMostrado: enmascararEmail(boleta.value.contacto.correo) },
  ];
});

const canalElegidoTexto = computed(() => {
  if (!boleta.value) return "";
  return canalSeleccionado.value === "correo"
    ? enmascararEmail(boleta.value.contacto.correo)
    : enmascararFono(boleta.value.contacto.fono);
});

const textoContadorOtp = computed(() => {
  if (segundosOtp.value <= 0) return "El código venció";
  const min = Math.floor(segundosOtp.value / 60);
  const seg = String(segundosOtp.value % 60).padStart(2, "0");
  return `El código vence en ${min}:${seg}`;
});

const mostrarAvisoAnulacion = computed(() => form.motivo.includes("anular"));

// --- Funciones ---
function enmascararEmail(correo) {
  const [usuario, dominio] = correo.split("@");
  return usuario.slice(0, 2) + "•".repeat(Math.max(3, usuario.length - 2)) + "@" + dominio;
}

function enmascararFono(fono) {
  const soloDigitos = fono.replace(/\D/g, "");
  return "+56 9 •••• " + soloDigitos.slice(-4);
}

async function guardarQr() {
  try {
    const res = await fetch(qrAccesoRapido.value);
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `boleta-${boleta.value.folio}-qr.png`;
    a.click();
    URL.revokeObjectURL(url);
  } catch (e) {
    debug.error("no se pudo descargar el QR", e);
    window.open(qrAccesoRapido.value, "_blank");
  }
}

function irAConsulta(desde) {
  etapaAnteriorConsulta.value = desde;
  etapa.value = "consulta";
}

function abrirWhatsapp() {
  window.open("https://wa.me/56900000000", "_blank");
}

function reiniciarPorSesionExpirada() {
  store.commit('boletas/SET_SESION_EXPIRADA', false);
  reiniciar(); // ya existe, vuelve a etapa 'modo' y limpia el form
}

// convierte el pdf en base64 que devuelve el backend en una url utilizable por el navegador (iframe/descarga)
function base64APdfUrl(pdf_base64) {
  const binario = atob(pdf_base64);
  const bytes = new Uint8Array(binario.length);
  for (let i = 0; i < binario.length; i++) {
    bytes[i] = binario.charCodeAt(i);
  }
  const blob = new Blob([bytes], { type: "application/pdf" });
  return URL.createObjectURL(blob);
}

// pide el pdf real al backend y lo deja listo para mostrarse en el iframe del panel izquierdo
async function cargarPdfEnPanel() {
  cargandoPdfPanel.value = true;
  errorPdfPanel.value = false;

  try {
    const { pdf_base64 } = await descargarPdfBoleta(boleta.value.folio);
    pdfUrl.value = base64APdfUrl(pdf_base64);
  } catch (e) {
    debug.error("cargarPdfEnPanel falló", e);
    errorPdfPanel.value = true;
  } finally {
    cargandoPdfPanel.value = false;
  }
}

async function revisarAccesoRapido() {
  if (typeof window === "undefined") return;

  const params = new URLSearchParams(window.location.search);
  const tokenQr = params.get("t");
  if (!tokenQr) return;

  cargando.value = true;

  try {
    const encontrada = await validarAccesoRapido(tokenQr);
    boleta.value = encontrada;
    etapa.value = "resultado";
  } catch (e) {
    debug.error("acceso rápido falló", e);
    errorFolio.value = "Este enlace ya no es válido. Búscala de nuevo.";
    etapa.value = "folio";
  } finally {
    cargando.value = false;
  }
}

// reutiliza el pdf ya cargado en el panel, no vuelve a pedirlo al servidor
function descargarPdf() {
  if (!pdfUrl.value) return;
  const a = document.createElement("a");
  a.href = pdfUrl.value;
  a.download = `boleta-${boleta.value.folio}.pdf`;
  a.click();
}

async function enviarConsulta() {
  errorConsulta.value = "";

  if (!form.motivo) {
    errorConsulta.value = "Elige un motivo para tu consulta.";
    return;
  }
  if (form.detalle.trim().length < 15) {
    errorConsulta.value = "Cuéntanos un poco más: necesitamos al menos una frase para poder ayudarte.";
    return;
  }
  if (form.contacto.replace(/\D/g, "").length < 8) {
    errorConsulta.value = "Deja un teléfono válido para responderte.";
    return;
  }

  cargando.value = true;

  try {
    const resultado = await enviarConsultaBoleta({
      folio: boleta.value.folio,
      motivo: form.motivo,
      detalle: form.detalle,
      contacto: form.contacto,
    });
    ticket.value = resultado.ticket;
    etapa.value = "listo";
  } catch (e) {
    debug.error("enviarConsulta falló", e);
    errorConsulta.value = "No pudimos enviar tu consulta. Intenta de nuevo.";
  } finally {
    cargando.value = false;
  }
}

function reiniciar() {
  etapa.value = "modo";
  form.folio = "";
  form.monto = "";
  form.patente = "";
  form.correo = "";
  form.fecha = "";
  form.motivo = "";
  form.detalle = "";
  form.contacto = "";
  boleta.value = null;
  pdfUrl.value = null;
  errorPdfPanel.value = false;
}

function iniciarContadorOtp() {
  clearInterval(timerOtp);
  segundosOtp.value = 300;
  reenvioSegundos.value = 60;
  timerOtp = setInterval(() => {
    if (segundosOtp.value > 0) segundosOtp.value--;
    if (reenvioSegundos.value > 0) reenvioSegundos.value--;
    if (segundosOtp.value === 0 && reenvioSegundos.value === 0) clearInterval(timerOtp);
  }, 1000);
}

async function enviarCodigo() {
  errorOtp.value = "";
  cargando.value = true;

  try {
    await enviarCodigoOtp(boleta.value.folio, canalSeleccionado.value);
    codigoOtp.value = ["", "", "", "", "", ""];
    etapa.value = "otp";
    iniciarContadorOtp();
  } catch (e) {
    debug.error("enviarCodigo falló", e);
    errorOtp.value = "No pudimos enviar el código. Intenta de nuevo.";
  } finally {
    cargando.value = false;
  }
}

function reenviarCodigo() {
  if (reenvioSegundos.value > 0) return;
  codigoOtp.value = ["", "", "", "", "", ""];
  errorOtp.value = "";
  iniciarContadorOtp();
}

function onInputOtp(indiceCasilla, evento) {
  codigoOtp.value[indiceCasilla] = evento.target.value.replace(/\D/g, "").slice(0, 1);
  if (codigoOtp.value[indiceCasilla] && indiceCasilla < 5) casillasOtpRef.value?.focusCasilla(indiceCasilla + 1);
  if (codigoOtp.value.every((c) => c)) validarCodigo();
}

function onKeydownOtp(indiceCasilla, evento) {
  if (evento.key === "Backspace" && !codigoOtp.value[indiceCasilla] && indiceCasilla > 0) casillasOtpRef.value?.focusCasilla(indiceCasilla - 1);
  if (evento.key === "ArrowLeft" && indiceCasilla > 0) casillasOtpRef.value?.focusCasilla(indiceCasilla - 1);
  if (evento.key === "ArrowRight" && indiceCasilla < 5) casillasOtpRef.value?.focusCasilla(indiceCasilla + 1);
}

async function validarCodigo() {
  const codigo = codigoOtp.value.join("");
  if (codigo.length < 6) return;

  errorOtp.value = "";
  cargando.value = true;

  try {
    await validarCodigoOtp(boleta.value.folio, codigo);
    clearInterval(timerOtp);
    etapa.value = "verificado";
    cargarPdfEnPanel();
  } catch (e) {
    debug.error("validarCodigo falló", e);
    errorOtp.value = "Código incorrecto. Verifica los 6 dígitos.";
  } finally {
    cargando.value = false;
  }
}

function tengoBoleta() {
  etapa.value = "folio";
}

function noTengoBoleta() {
  etapa.value = "patente";
}

async function buscarPorFolio() {
  errorFolio.value = "";

  if (!form.folio) {
    errorFolio.value = "Ingresa el número de folio.";
    return;
  }

  const monto = parseInt(form.monto.replace(/[^\d]/g, ""), 10);
  if (!monto) {
    errorFolio.value = "Ingresa el total pagado.";
    return;
  }

  cargando.value = true;

  try {
    const encontrada = await buscarBoletaPorFolio(form.folio, monto);
    boleta.value = encontrada;
    etapa.value = "resultado";
  } catch (e) {
    debug.error("buscarPorFolio falló", e);
    errorFolio.value = "No encontramos una boleta con esos datos. Revísalos e intenta de nuevo.";
  } finally {
    cargando.value = false;
  }
}

async function buscarPorPatente() {
  errorPatente.value = "";

  const patente = form.patente.toUpperCase().replace(/[^A-Z0-9]/g, "");
  if (patente.length < 4) {
    errorPatente.value = "Ingresa una patente válida.";
    return;
  }

  const correo = form.correo.trim().toLowerCase();
  if (!/^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(correo)) {
    errorPatente.value = "Ingresa un correo válido.";
    return;
  }

  cargando.value = true;

  try {
    const encontradas = await buscarBoletasPorPatente(patente, correo, form.fecha || null);

    if (encontradas.length === 0) {
      errorPatente.value = "No encontramos boletas con esos datos.";
      return;
    }

    if (encontradas.length === 1) {
      boleta.value = encontradas[0];
      etapa.value = "resultado";
      return;
    }

    boletasEncontradas.value = encontradas;
    etapa.value = "lista";
  } catch (e) {
    debug.error("buscarPorPatente falló", e);
    errorPatente.value = "No pudimos completar la búsqueda. Intenta de nuevo.";
  } finally {
    cargando.value = false;
  }
}

function elegirBoleta(b) {
  boleta.value = b;
  etapa.value = "resultado";
}

// --- Lifecycle hooks ---
onMounted(() => {
  debug.log('montado panel boleta');
  revisarAccesoRapido();
})

</script>

<style scoped>
.efecto_fondo {
  background-image:
    linear-gradient(rgba(20, 22, 26, .035) 1px, transparent 1px),
    linear-gradient(90deg, rgba(20, 22, 26, .035) 1px, transparent 1px);
  background-size: 28px 28px;
}
</style>